const Title = (props) => {
  let { text, ...rest } = props;

  return <h2 {...rest}>{text}</h2>;
};

export default Title;
